var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnliked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhoneX",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s0501---marketplace",
    transform: "translate(-330.000000, -719.000000)",
    fill: "#000000",
    fillOpacity: 0.3,
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.469298,736.346439 C340.469435,736.346573 340.469572,736.346708 340.469709,736.346842 C340.469572,736.346707 340.469435,736.346573 340.469298,736.346438 Z M339.53348,736.343689 C339.532578,736.344577 339.531678,736.345467 339.530781,736.34636 C339.531687,736.345469 339.532598,736.344574 339.533511,736.343675 Z M339.999991,735.882811 C340.686981,735.202451 341.833308,734.062495 342.866572,733.027316 C345.065257,730.824557 346.74509,729.108226 347.572316,728.202702 C348.515464,727.170144 349,726.016565 349,724.855136 C349,722.268055 346.850804,720.154842 344.202667,720.154842 C342.878989,720.154842 341.626462,720.684772 340.719553,721.624481 L340,722.370058 L339.280447,721.624481 C338.373538,720.684772 337.121011,720.154842 335.797333,720.154842 C333.149196,720.154842 331,722.268055 331,724.855136 C331,726.016565 331.484536,727.170144 332.427639,728.202652 C333.254909,729.108225 334.934882,730.824698 337.133678,733.02757 C338.163422,734.059223 339.315362,735.204769 339.999991,735.882811 Z",
    id: "Shape-Copy-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnliked);
export default __webpack_public_path__ + "static/media/unliked.2919098a3a93c4f46982f69862a5b319.svg";
export { ForwardRef as ReactComponent };